export default __webpack_public_path__ + "static/media/profile_engagement.a38b29bf.svg";